export default __webpack_public_path__ + "static/media/payment_successful.b417743d.gif";